var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_4151_43036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 120.334C81.244 120.334 85.5 124.59 85.5 129.834C85.5 135.078 81.244 139.334 76 139.334C70.756 139.334 66.5 135.078 66.5 129.834C66.5 124.59 70.756 120.334 76 120.334ZM76 12.667C96.9887 12.667 114 29.6783 114 50.667C114 64.3787 109.231 71.5037 97.0647 81.846C84.8603 92.2137 82.3333 96.8813 82.3333 107.667H69.6667C69.6667 91.9983 74.651 84.2653 88.863 72.194C98.4707 64.0303 101.333 59.749 101.333 50.667C101.333 36.6703 89.9967 25.3337 76 25.3337C62.0033 25.3337 50.6667 36.6703 50.6667 50.667V57.0003H38V50.667C38 29.6783 55.0113 12.667 76 12.667Z",
    fill: "#0095FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4151_43036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.eb016fe3cf64b13d045041dc2cea07a1.svg";
export { ForwardRef as ReactComponent };